/**
 * Checks if a string is a number.
 */
export const isNumberString = (str?: string) => str?.match(/^\d+$/);
